import React from "react";
import { Link } from "react-router-dom";
import { RESIDENTIAL_PLANS, RESIDENTIAL_PRICING_NOTE } from "@/data/maintenancePlans";

export default function HomeMaintenanceHighlight() {
  return (
    <section className="section-pad bg-white">
      <div className="container-br grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-6">
          <div className="br-eyebrow">Maintenance Memberships</div>
          <h2 className="br-headline text-3xl sm:text-4xl mt-3">Get a Trusted Contractor on Call</h2>
          <p className="mt-3 text-gray-700">Monthly maintenance memberships designed for Austin homeowners, busy families, rental owners, and investors who want a real general contractor familiar with their property. Plans include planned visits, a defined annual covered-work allowance, priority scheduling, and member pricing on approved repairs.</p>
          <p className="mt-3 text-xs text-gray-500 leading-relaxed">Memberships are repair reserve agreements with defined covered scopes and limits. They are not home insurance, warranties, or unlimited-repair programs.</p>
          <p className="mt-2 text-xs text-gray-500 leading-relaxed italic">{RESIDENTIAL_PRICING_NOTE}</p>
          <div className="mt-5 flex flex-wrap gap-3">
            <Link to="/maintenance-plans" className="br-btn-dark">View All Plans</Link>
            <Link to="/contact" className="br-btn-secondary text-br-black border-br-black hover:text-br-bronze hover:border-br-bronze" style={{color:"#0a0a0a", borderColor:"#0a0a0a"}}>Get on the Maintenance List</Link>
          </div>
        </div>
        <div className="lg:col-span-6 grid sm:grid-cols-2 gap-4">
          {RESIDENTIAL_PLANS.slice(0,4).map((p) => (
            <Link to="/maintenance-plans" key={p.id} className={`p-5 border rounded ${p.highlight ? "border-br-bronze bg-br-paper" : "border-gray-200 bg-white"} hover:border-br-bronze transition`}>
              <div className="br-eyebrow text-br-bronze">{p.highlight ? "Most Popular" : "Plan"}</div>
              <div className="font-display text-lg tracking-wider uppercase mt-1">{p.name}</div>
              {p.pricePrefix && (
                <div className="text-[10px] tracking-[0.3em] uppercase text-gray-500 mt-2">{p.pricePrefix}</div>
              )}
              <div className="mt-0.5 text-2xl font-bold">${p.price}<span className="text-xs text-gray-500 font-normal ml-1">/mo</span></div>
              <p className="mt-2 text-xs text-gray-600 leading-relaxed">{p.bestFor}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
